module.exports = __webpack_public_path__ + "img/android-device-icon.2977c33d.svg";